// extracted by mini-css-extract-plugin
export default {"fSection":"Footer_fSection__BMNnZ","fCopyright":"Footer_fCopyright__R4DkT"};